export enum IdsDataGridFilterAttributes {
  filterConditionButton = 'data-filter-conditions-button'
}
